import { EgpSeason } from '../egp.service';

import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  inject,
  Injector,
  input,
  OnInit,
  signal,
  untracked,
} from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { isNil } from 'src/utils/utils';

export const MODULES = [CommonModule, TranslateModule];
export const COMPONENTS = [FaIconComponent];

@Component({
  selector: 'app-riskbar',
  templateUrl: './riskbar.component.html',
  styleUrls: ['./riskbar.component.css'],
  imports: [...MODULES, ...COMPONENTS],
})
export class RiskbarComponent implements OnInit {
  private injector = inject(Injector);
  public translate = inject(TranslateService);

  riskBoxdata = input<any>();
  season = input<string>();

  classes = {};
  symbols = signal({});
  translationGroup = 'PRODUCT.EGP.RISKBOX.';

  ngOnInit(): void {
    this.listenToSeasonChanges();
    this.listenToRiskBoxDataChanges();
  }

  createRiskBar(): void {
    const classSuffix = this.season() === EgpSeason.WINTER ? '' : '-summer';
    const riskBoxdata = this.riskBoxdata();
    for (const type in riskBoxdata) {
      if (riskBoxdata[type].regionPercent > 0) {
        this.classes[type] = 'riskbar-box yes-' + type + classSuffix;
        this.symbols.update(symbols => {
          return { ...symbols, [type]: 'check' };
        });
      } else {
        this.classes[type] = 'riskbar-box no-' + type + classSuffix;
        this.symbols.update(symbols => {
          return { ...symbols, [type]: 'minus' };
        });
      }
    }
  }

  getSeasonClassName(winterClass): string {
    const mapping = {
      EIS: 'HEAT',
      NAESSE: 'DRAIN',
      SCHNEE: 'STORM',
      REIF: 'THUNDER',
    };

    return this.season() === 'winter' ? winterClass : mapping[winterClass];
  }

  private listenToSeasonChanges() {
    effect(
      () => {
        const season = this.season();

        untracked(() => {
          this.translationGroup =
            season === EgpSeason.WINTER
              ? 'PRODUCT.EGP.RISKBOX.'
              : 'PRODUCT.EGP-SUMMER.RISKBOX.';
        });
      },
      { injector: this.injector }
    );
  }

  private listenToRiskBoxDataChanges() {
    effect(
      () => {
        const riskBoxdata = this.riskBoxdata();

        untracked(() => {
          // TODO: riskBoxData change
          if (!isNil(riskBoxdata)) {
            this.createRiskBar();
          }
        });
      },
      { injector: this.injector }
    );
  }
}
